import { render, staticRenderFns } from "./CreateAirQuality.vue?vue&type=template&id=3ee0f024"
import script from "./CreateAirQuality.vue?vue&type=script&lang=js"
export * from "./CreateAirQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports